import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseDeletePrivateCompanyLeadContractFeeProps {
  privateCompanyLeadId?: string
  onSuccess: () => void
  onError: () => void
}

const useDeletePrivateCompanyLeadContractFee = ({ privateCompanyLeadId, onSuccess, onError }: UseDeletePrivateCompanyLeadContractFeeProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['deletePrivateCompanyLeadContractFee'],
    mutationFn: async (id: string) => {
      const private_company_lead = {
        contract_attributes: {
          contract_fees_attributes: [
            {
              id,
              _destroy: true
            }
          ]
        }
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useDeletePrivateCompanyLeadContractFee